import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { Collaborator, ICollaborator } from '../Collaborator.ts';
import { CollaboratorApi } from '../../../apis/CollaboratorApi/CollaboratorApi.ts';
import { patientStore } from '../../../Store/Store.ts';

export function useGetPatientCollaborators() {
    const patientId = patientStore.patientId;
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.collaborators],
        queryFn: async () => {
            const result: ICollaborator[] = await CollaboratorApi.getPatientCollaborators(patientId!);
            return result?.map((x) => new Collaborator(x)) ?? [];
        },
        enabled: !!patientId && patientId != '0',
    });
}
